module.exports={
	"Form": "OrganizationCreateManifest",
	"Scope": "Organization-Create",
	"Descriptors":
	{
		"OrganizationDetails.Name":
		{
			"Name": "Organization Name",
			"Hash": "OrgCreate-Name",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "Text",
				"Row": "1",
				"Width": 12,
				"Section": "OrgCreateIdentity",
				"Group": "OrgCreateIdentity"
			}
		},
		"OrganizationDetails.Type":
		{
			"Name": "Type",
			"Hash": "OrgCreate-Type",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "Text",
				"Row": "2",
				"Width": 4,
				"Section": "OrgCreateDetails",
				"Group": "OrgCreateDetails"
			}
		},
		"OrganizationDetails.VendorCode":
		{
			"Name": "Vendor Code",
			"Hash": "OrgCreate-VendorCode",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "Text",
				"Row": "2",
				"Width": 4,
				"Section": "OrgCreateDetails",
				"Group": "OrgCreateDetails"
			}
		},
		"OrganizationDetails.ExternalOrganizationID":
		{
			"Name": "External Organization ID",
			"Hash": "OrgCreate-ExternalOrgID",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "Text",
				"Row": "2",
				"Width": 4,
				"Section": "OrgCreateDetails",
				"Group": "OrgCreateDetails"
			}
		},
		"OrganizationDetails.Approved":
		{
			"Name": "Approved",
			"Hash": "OrgCreate-Approved",
			"DataType": "Boolean",
			"PictForm":
			{
				"InputType": "Boolean",
				"Row": "3",
				"Width": 3,
				"Section": "OrgCreateDetails",
				"Group": "OrgCreateDetails"
			}
		},
		"OrganizationDetails.DisadvantagedBusiness":
		{
			"Name": "Disadvantaged Business",
			"Hash": "OrgCreate-DisadvantagedBusiness",
			"DataType": "Boolean",
			"PictForm":
			{
				"InputType": "Boolean",
				"Row": "3",
				"Width": 4,
				"Section": "OrgCreateDetails",
				"Group": "OrgCreateDetails"
			}
		},
		"OrganizationDetails.Email":
		{
			"Name": "Email",
			"Hash": "OrgCreate-Email",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "Text",
				"Row": "4",
				"Width": 6,
				"Section": "OrgCreateContact",
				"Group": "OrgCreateContact"
			}
		},
		"OrganizationDetails.Phone":
		{
			"Name": "Phone",
			"Hash": "OrgCreate-Phone",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "Text",
				"Row": "4",
				"Width": 6,
				"Section": "OrgCreateContact",
				"Group": "OrgCreateContact"
			}
		},
		"OrganizationDetails.Address":
		{
			"Name": "Address",
			"Hash": "OrgCreate-Address",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "Text",
				"Row": "5",
				"Width": 12,
				"Section": "OrgCreateAddress",
				"Group": "OrgCreateAddress"
			}
		},
		"OrganizationDetails.City":
		{
			"Name": "City",
			"Hash": "OrgCreate-City",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "Text",
				"Row": "6",
				"Width": 4,
				"Section": "OrgCreateAddress",
				"Group": "OrgCreateAddress"
			}
		},
		"OrganizationDetails.State":
		{
			"Name": "State",
			"Hash": "OrgCreate-State",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "Text",
				"Row": "6",
				"Width": 4,
				"Section": "OrgCreateAddress",
				"Group": "OrgCreateAddress"
			}
		},
		"OrganizationDetails.Zip":
		{
			"Name": "ZIP Code",
			"Hash": "OrgCreate-Zip",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "Text",
				"Row": "6",
				"Width": 4,
				"Section": "OrgCreateAddress",
				"Group": "OrgCreateAddress"
			}
		}
	},
	"Sections":
	[
		{
			"Name": "Identity",
			"Hash": "OrgCreateIdentity",
			"Solvers": [],
			"ShowTitle": true,
			"Groups":
			[
				{
					"Name": "Identity",
					"Hash": "OrgCreateIdentity",
					"Rows": [],
					"RecordSetSolvers": [],
					"ShowTitle": false
				}
			]
		},
		{
			"Name": "Details",
			"Hash": "OrgCreateDetails",
			"Solvers": [],
			"ShowTitle": true,
			"Groups":
			[
				{
					"Name": "Details",
					"Hash": "OrgCreateDetails",
					"Rows": [],
					"RecordSetSolvers": [],
					"ShowTitle": false
				}
			]
		},
		{
			"Name": "Contact",
			"Hash": "OrgCreateContact",
			"Solvers": [],
			"ShowTitle": true,
			"Groups":
			[
				{
					"Name": "Contact",
					"Hash": "OrgCreateContact",
					"Rows": [],
					"RecordSetSolvers": [],
					"ShowTitle": false
				}
			]
		},
		{
			"Name": "Address",
			"Hash": "OrgCreateAddress",
			"Solvers": [],
			"ShowTitle": true,
			"Groups":
			[
				{
					"Name": "Address",
					"Hash": "OrgCreateAddress",
					"Rows": [],
					"RecordSetSolvers": [],
					"ShowTitle": false
				}
			]
		}
	]
}
